<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <el-row class="steps">
          <el-col :span="24">
            <el-steps
              :active="active"
              align-center
              simple
              finish-status="success"
            >
              <el-step
                v-for="item in steps"
                :key="item.title"
                :title="item.title"
                :description="item.description"
              />
            </el-steps>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-select v-model="value" placeholder="请选择" size="medium" class="address-select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="primary" size="medium" class="manage-bill-btn" @click="manageBill">管理开票信息</el-button>
        </el-row> -->
          <el-alert
            class="alert"
            title="请确保开票信息无误，如有更改请及时修改或联系客服人员"
            type="warning"
            show-icon
            :closable="false">
          </el-alert>
          <el-form ref="form"  :model="form" label-width="100px" :rules="rules" class="bill-info-form" :label-position="'top'">
            <el-row>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="invoice_title" disabled>
                    <template slot="label">
                      <div class="bill-info-title">企业名称</div>
                    </template>
                    <el-input v-model="form.invoice_title" disabled />
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="company_phone">
                    <template slot="label">
                      <div class="bill-info-title">企业电话</div>
                    </template>
                    <el-input v-model="form.company_phone" disabled/>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="taxpayer">
                    <template slot="label">
                      <div class="bill-info-title">企业税号</div>
                    </template>
                    <el-input v-model="form.taxpayer" disabled/>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="company_bank">
                    <template slot="label">
                      <div class="bill-info-title">开户行</div>
                    </template>
                    <el-input v-model="form.company_bank" disabled/>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="company_address">
                    <template slot="label">
                      <div class="bill-info-title">企业地址</div>
                    </template>
                    <el-input v-model="form.company_address" disabled/>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="company_account">
                    <template slot="label">
                      <div class="bill-info-title">银行账号</div>
                    </template>
                    <el-input v-model="form.company_account" disabled/>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <div v-if="$route.query.yt">
              <div v-for="(item, index) in form.ytCategoryList" :key="index" class="fenge">
                <div class="">
                  <el-button type="primary" size="medium" icon="el-icon-circle-plus-outline" @click="addYTcategory(index)">新增一条</el-button>
                  可开票金额：{{ item.money }}
                </div>
                <el-row v-for="(category_item,category_index) in item.category" :key="category_index" style="display: flex;align-items: flex-end;justify-content: center;">
                  <el-col :span="12">
                    <div class="bill-info">
                      <el-form-item :prop="'ytCategoryList.' + index + '.category.' + category_index + '.category_id'"
                        :rules="{
                          required: true, message: '请输入开票类目', trigger: 'blur'
                        }"
                      >
                      <template slot="label">
                        <div class="bill-info-title">开票类目</div>
                      </template>
                      <el-select filterable v-model="form.ytCategoryList[index].category[category_index].category_id" :disabled="disabled" @change="selectYTCatory" placeholder="请选择开票类目" style="width: 100%" >
                        <el-option v-for="i in options1" :key="i.category_id" :label="i.display_name" :value="i.category_id"></el-option>
                      </el-select>
                      </el-form-item>
                    </div>
                  </el-col>
          
                  <el-col :span="11">
                    <div class="bill-info">
                      <el-form-item
                        :prop="'ytCategoryList.' + index + '.category.' + category_index + '.category_money'"
                        :rules="[{
                          required: true, message: '请输入申请开票金额', trigger: 'blur'
                        }]"
                      >
                        <template slot="label">
                          <div class="bill-info-title">开票金额</div>
                        </template>
                        <div class="business-address">
                          <el-input v-model="form.ytCategoryList[index].category[category_index].category_money" :disabled="disabled"/><i class="iconfont iconiconmoney priceIcon"></i>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col span="1">
                    <div style="padding: 20px 0;">
                      <el-button @click="deleteYTcategory(index,category_index)" v-if="category_index" size="mini" type="danger" icon="el-icon-minus" circle />
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="fenge"></div>
            </div>
			
          <div v-else class="fenge">
              <el-row v-for="(item, index) in form.category" :key="index">
                <el-col :span="12" v-if="isLaowuCompany == true">
                <div class="bill-info">
                <el-form-item
                prop="laowuForm_id"
                :rules="{
                required: true, message: '请选择税局', trigger: 'blur'
                }"
                >
                <template slot="label">
                <div class="bill-info-title">税局</div>
                </template>
                <el-select filterable v-model="laowuForm.mb_arr.id" :disabled="disabled" @change="event_getTaxRow($event)" placeholder="请选择税局" style="width: 100%" >
                <el-option
                v-for="i in taxCompany"
                :key="i.bmid"
                :label="i.cCompanyname"
                :value="i.bmid">
                </el-option>
                </el-select>
                </el-form-item>
                </div>
                </el-col>
               <el-col :span="12" v-if="isLaowuCompany == true">
                  <div class="bill-info">
                    <el-form-item
                      prop="laowuForm_type"
                      :rules="{
                        required: true, message: '请选择征收类目', trigger: 'blur'
                      }"
                    >
                      <template slot="label">
                        <div class="bill-info-title">征收类目</div>
                      </template>
                      <el-select @change="event_zsType" filterable v-model="laowuForm.mb_arr.type_name" :disabled="disabled" placeholder="请选择征收类目" style="width: 100%" >
                        <el-option
                          v-for="(i,i_index) in zsTypeList"
                          :key="i_index"
                          :label="i"
                          :value="i">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
				
				<el-col :span="12" v-if="isLaowuCompany == false">
				<div class="bill-info">
				<el-form-item
				:prop="'category.'+ index + '.category_id'"
				:rules="{
				required: true, message: '请输入开票类目', trigger: 'blur'
				}"
				>
				<template slot="label">
				<div class="bill-info-title">开票类目</div>
				</template>
				<el-select filterable v-model="item.category_id" :disabled="disabled" @change="selectCatory" placeholder="请选择开票类目" style="width: 100%" >
				<el-option
				v-for="i in options1"
				:key="i.category_id"
				:label="i.display_name"
				:value="i.category_id">
				</el-option>
				</el-select>
				</el-form-item>
				</div>
				</el-col>
				
                <el-col :span="12" v-if="isLaowuCompany == false">
                  <div class="bill-info">
                    <el-form-item
                      :prop="'category.'+ index + '.category_money'"
                      :rules="[{
                        required: true, message: '请输入申请开票金额', trigger: 'blur'
                      }]"
                    >
                      <template slot="label">
                        <div class="bill-info-title">开票金额</div>
                      </template>
                      <div class="business-address">
                        <el-input v-model="item.category_money" :disabled="disabled || selectIds.length"/><i class="iconfont iconiconmoney priceIcon"></i>
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>

            <el-row>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="invoice_type">
                    <template slot="label">
                      <div class="bill-info-title">开票类型</div>
                    </template>
                    <el-select v-model="form.invoice_type" :disabled="disabled" placeholder="请选择开票类型" style="width: 100%">
                      <el-option
                        v-for="item in this.options2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="remark">
                    <template slot="label">
                      <div class="bill-info-title">发票右下角备注信息</div>
                    </template>
                    <el-input v-model="form.remark" :disabled="disabled"/>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
			
			<el-row>
			<el-col :span="12" v-if="isLaowuCompany == true">
			<div class="bill-info">
			<el-form-item
			prop="project_name"
			:rules="[{
			required: true, message: '请输入项目名称', trigger: 'blur'
			}]"
			>
			<template slot="label">
			<div class="bill-info-title">项目名称</div>
			</template>
			<el-input v-model="form.project_name" :disabled="disabled" placeholder="请输入项目名称"/>
			</el-form-item>
			</div>
			</el-col>
			</el-row>
			
            <el-row v-if="isLaowuCompany == false">
              <div class="bill-mail-info">
                <el-form-item prop="receiver_address">
                  <template slot="label">
                    <div class="mail-info-title">收件地址：</div>
                  </template>
                  <el-input v-model="form.receiver_address" :disabled="disabled"/>
                </el-form-item>
                <el-form-item prop="receiver_fullname">
                  <template slot="label">
                    <div class="mail-info-title">收件人：</div>
                  </template>
                  <el-input v-model="form.receiver_fullname" :disabled="disabled"/>
                </el-form-item>
                <el-form-item prop="receiver_phone">
                  <template slot="label">
                    <div class="mail-info-title">收件人电话：</div>
                  </template>
                  <el-input v-model="form.receiver_phone" :disabled="disabled"/>
                </el-form-item>
                <el-form-item prop="receiver_email">
                  <template slot="label">
                    <div class="mail-info-title">电子发票接收邮件：</div>
                  </template>
                  <el-input v-model="form.receiver_email" :disabled="disabled"/>
                </el-form-item>
              </div>
            </el-row>
			<div v-if="isLaowuCompany == true">
				<div>
					<span>请选择本次申请开票的提现记录：</span>
					<el-button type="primary" @click="event_addTXperson">增加</el-button>
				</div>
			<el-table
			:data="txRecordList_finally"
			@selection-change="event_txSelect_finally"
			style="width: 100%;margin-top: 20px;">
			<el-table-column
			type="selection"
			width="55">
			</el-table-column>
			<el-table-column
			type="index"
			label="序号"
			:index="indexMethod">
			</el-table-column>
			<el-table-column
			prop="orderNo"
			label="提现订单号"
			width="180">
			</el-table-column>
			<el-table-column
			prop="fullName"
			label="姓名">
			</el-table-column>
			<el-table-column
			prop="money"
			label="金额">
			</el-table-column>
			<el-table-column
			prop="idNumber"
			label="身份证号">
			</el-table-column>
			<el-table-column
			prop="mobile"
			label="手机号">
			</el-table-column>
			<el-table-column
			prop="laborDispatchMoney"
			label="劳务费">
			</el-table-column>
			</el-table>
			</div>
          </el-form>
          <el-row class="save-btn-wrapper">
            <el-button type="primary" size="medium" @click="saveClick('form')" v-if="this.$route.query.save">保存</el-button>
            <el-button type="primary" size="medium" @click="toReview()" v-if="this.$route.query.review">复核</el-button>
          </el-row>
      </div>
    </PageHeaderLayout>
	
	<ModalDialog :dialogData="txpersonDialogData" @dialogConfirm="txpersonConfirm" @dialogClose="txpersonDialogClose" :showButton="showButton">
		<template slot="content">
			<div>
				<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
				<el-form-item label="订单号">
				<el-input @input="event_changeSearch" v-model="searchCondition.orderNo" placeholder="订单号"></el-input>
				</el-form-item>
				<el-form-item label="姓名">
				<el-input @input="event_changeSearch" v-model="searchCondition.fullName" placeholder="姓名"></el-input>
				</el-form-item>
				<el-form-item label="身份证号">
				<el-input @input="event_changeSearch" v-model="searchCondition.idNumber" placeholder="身份证号"></el-input>
				</el-form-item>
				<el-form-item label="手机号">
				<el-input @input="event_changeSearch" v-model="searchCondition.mobile" placeholder="手机号"></el-input>
				</el-form-item>
				<el-form-item label="提现起止时间">
					<el-date-picker
					v-model="searchCondition.time"
					type="datetimerange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd HH:mm:ss"
					@change="event_changeSearch"
					>
					</el-date-picker>
				</el-form-item>
				</el-form>
			</div>
			<el-table
			@selection-change="event_txSelect"
			:data="txRecordList"
			style="width: 100%;margin-top: 20px;">
			<el-table-column
			type="selection"
			width="55">
			</el-table-column>
			<el-table-column
			type="index"
			label="序号"
			:index="indexMethod">
			</el-table-column>
			<el-table-column
			prop="orderNo"
			label="提现订单号"
			width="180">
			</el-table-column>
			<el-table-column
			prop="fullName"
			label="姓名">
			</el-table-column>
			<el-table-column
			prop="money"
			label="金额">
			</el-table-column>
			<el-table-column
			prop="idNumber"
			label="身份证号">
			</el-table-column>
			<el-table-column
			prop="mobile"
			label="手机号">
			</el-table-column>
			<el-table-column
			prop="laborDispatchMoney"
			label="劳务费">
			</el-table-column>
			</el-table>
		</template>
	</ModalDialog>
	
    <ModalDialog :dialogData="toReviewDialogData" @dialogConfirm="toReviewHandleConfirm" @dialogClose="toReviewDialogClose" :showButton="showButton">
        <template slot="content">
          <el-form :model="toReviewRuleForm" ref="toReviewRuleForm" class="demo-ruleForm" :label-position="'right'" >
            <el-form-item>
              <el-radio-group v-model="toReviewRuleForm.invoice_status" @change="selectRadio">
                <el-radio label="3">通过</el-radio>
                <el-radio label="5">驳回</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="toReviewRuleForm.invoice_status == 5">
              <el-input type="textarea" :rows="4" v-model="toReviewRuleForm.review_remark" placeholder="请输入驳回原因"></el-input>
            </el-form-item>
          </el-form>
        </template>
      </ModalDialog>
	
		<ModalDialog :dialogData="errorDialog" @dialogClose="event_errorDialogClose" @dialogConfirm="event_errorDialogClose" :showButton="showButton">
		<template slot="content">
			<el-table
			:data="errorList"
			style="width: 100%;margin-top: 20px;">
			<el-table-column
			prop="bank_account_name"
			label="姓名"
			width="100">
			</el-table-column>
			<el-table-column
			prop="outer_trade_no"
			label="订单号"
			width="280">
			</el-table-column>
			<el-table-column
			prop="id_number"
			label="身份证号">
			</el-table-column>
			<el-table-column
			prop="ybs_err_message"
			label="错误信息">
			</el-table-column>
			</el-table>
		</template>
		</ModalDialog>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from '@/components/ModalDialog'
export default {
  components: {
    PageHeaderLayout,
    ModalDialog
  },
  watch: {
    "toReviewRuleForm.invoice_status": function(val) {
      if(val) {
        this.toReviewDialogData.loading = false
      }else {
        this.toReviewDialogData.loading = true
      }
    }
  },
  data() {
    var nowCompany = localStorage.getItem('nowCompany')?JSON.parse(localStorage.getItem('nowCompany')):{};
    // var checkMoney = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('开票金额必填'));
    //   }
    //   if(nowCompany.trade_bank_type=='lingxin'){
    //      setTimeout(() => {
    //        if (value < 100000) {
    //          callback(new Error('开票金额需大于等于10万'));
    //        } else {
    //          callback();
    //        }
    //      }, 300);
    //   }else{
    //     callback();
    //   }
    // };
    return {
      selectIds:[],
		errorList:[],
		errorDialog:{
			visible: false,
			title: '错误列表',
			width: '70%'
		},
		zsTypeList:[],
		taxCompany:[],
		searchCondition:{
			orderNo:'',
			fullName:'',
			idNumber:'',
			mobile:'',
			time:[],
			start_time:'',
			end_time:''
		},
		txpersonDialogData:{
			visible: false,
			title: '',
			width: '70%'
		},
		txRecordList_finallySecond:[],
		txRecordList_temp:[],
		txRecordList_finally:[],
		txRecordList:[],
		isLaowuCompany:0,
        // checkMoney,
        nowCompany,
        settlement_id:localStorage.getItem('settlementId')?localStorage.getItem('settlementId').replace(/"/g,''):'',
      showButton: ['cancel'],
      options1: [],
      options2: [{
        label: "普通发票",
        value: 0,
      },
      {
        label: "增值税专用发票",
        value: 1,
      }],
      active: 1,
      steps: [
        {
          title: "申请开票",
          description: "",
          content: "step1",
        },
        {
          title: "平台审批",
          description: "",
          content: "step2",
        },
        {
          title: "发票开出",
          description: "",
          content: "step3",
        },
        {
          title: "发票寄出",
          description: "",
          content: "step4",
        },
      ],
      value: "",
		laowuForm:{
			mb_arr:{
				type_name: '',
				id: '',
				name:''
			}
		},
      form: {
        invoice_title: '',
        company_account: '',
        taxpayer: '',
        company_bank: '',
        company_address: '',
        remark: '',
        company_phone: '',
        receiver_address: '',
        receiver_fullname: '',
        receiver_phone: '',
        receiver_email:'',
        category:[
          {
            category_id: '',
            category_money: '',
          }
        ],
        invoice_type: '增值税专用发票',
		laowuForm_id:'',
		laowuForm_type:'',
    ytCategoryList:{},

      },
      rules: {
        invoice_title: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        company_account: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        taxpayer: [
          { required: true, message: '请输入企业税号', trigger: 'blur' }
        ],
        company_bank: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        company_address: [
          { required: true, message: '请输入企业地址', trigger: 'blur' }
        ],
        // remark: [
        //   { required: true, message: '请输入备注', trigger: 'blur' }
        // ],
        company_phone: [
          { required: true, message: '请输入企业电话', trigger: 'blur' },
          // { min:5, max:11, message: '请输入5到11位手机号', trigger: 'blur' }
        ],
        receiver_address: [
          { required: true, message: '请输入收件地址', trigger: 'blur' }
        ],
        receiver_fullname: [
          { required: true, message: '请输入收件人', trigger: 'blur' }
        ],
        receiver_phone: [
          { required: true, message: '请输入收件人电话', trigger: 'blur' },
          { min:11, message: '请输入11位手机号', trigger: 'blur' }
        ],
        invoice_type: [
          { required: true, message: '请选择开票类型', trigger: 'blur' }
        ],
		laowuForm_id:[
          { required: true, message: '请选择税局', trigger: 'blur' }
		]
      },
      disabled: false,
      toReviewRuleForm: {
        id: '',
        invoice_status: '',
        review_remark: ''
      },
      toReviewDialogData: {
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
    };
  },
  methods: {
	event_errorDialogClose(){
		this.errorDialog.visible = false	
	},
	async event_changeSearch(){
		let obj = {}
    if(this.searchCondition.time !== null && this.searchCondition.time !== undefined){
      if(this.searchCondition.time.length!=0){
        obj.start_time = this.searchCondition.time[0]
        obj.end_time = this.searchCondition.time[1]
      }
    }
		
		if(this.searchCondition.fullName){
			obj.fullName = this.searchCondition.fullName
		}
		if(this.searchCondition.idNumber){
			obj.idNumber = this.searchCondition.idNumber
		}
		if(this.searchCondition.mobile){
			obj.mobile = this.searchCondition.mobile
		}
		if(this.searchCondition.orderNo){
			obj.orderNo = this.searchCondition.orderNo
		}
		let result = await this.$api.laowuTxorderList(obj)
		this.txRecordList = result
	},
	event_zsType(e){
		this.form.laowuForm_type = e
	},
	event_getTaxRow(e){
		this.laowuForm.mb_arr.type_name = ''
		this.taxCompany.map(item=>{
			if(item.bmid == e){
				this.zsTypeList = item.zspms
				this.laowuForm.mb_arr.name = item.cCompanyname
			}
		})
		this.form.laowuForm_id = e
	},
	event_txSelect_finally(e){
		console.log(e,'选择shuju')
		this.txRecordList_finallySecond = e
	},
	event_txSelect(e){
		this.txRecordList_temp = e
	},
	txpersonConfirm(){
		this.txRecordList_finally = this.txRecordList_temp
		this.txpersonDialogData.visible  = false
	},
	txpersonDialogClose(){
		this.txpersonDialogData.visible  = false
	},
	async event_addTXperson(){
		let result = await this.$api.laowuTxorderList({})
		this.txRecordList = result
    this.searchCondition = {
			orderNo:'',
			fullName:'',
			idNumber:'',
			mobile:'',
			time:[],
			start_time:'',
			end_time:''
		}
		this.txpersonDialogData.visible  = true
		this.txRecordList_temp = []
	},
	indexMethod(index) {
	return index + 1;
	},
    //增加一条数据
    addClick() {
      let item = {
        category_id: this.form.category.category_id,
        category_money: this.form.category.category_money
      }
      this.form.category.push(item)
    },
    //删除一条数据
    deleteClick(index) {
      this.form.category.splice(index, 1)
    },
    //复核
    toReview() {
      this.toReviewRuleForm.id = this.$route.query.id
      this.toReviewDialogData.title = `复核${this.$route.query.id}`
      this.toReviewDialogData.visible = true
    },
    // 处理复核模态框，确定事件
    toReviewHandleConfirm() {
      // 调用组件的数据验证方法
      this.toReviewData();
      this.toReviewRuleForm = {}
      this.toReviewDialogData.visible = false
    },
    // 处理复核模态框，关闭事件
    toReviewDialogClose() {
      this.toReviewRuleForm = {}
      this.toReviewDialogData.visible = false
    },
    //选择复核状态
    selectRadio() {
      if(this.toReviewRuleForm.invoice_status == 3) {
        this.toReviewRuleForm.review_remark = ''
      }
    },
    //复核操作
    async toReviewData() {
      let result = await this.$api.toReview(this.toReviewRuleForm)
      if(result) {
        this.$message.success('复核成功')
      }else {
        this.$message.error('复核失败')
      }
      this.$router.push({path:'/invoice'})
    },
    // 管理开票信息
    manageBill() {
      console.log("管理开票信息")
    },
    // 保存
    saveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.$route.query.id) {
            this.editInvoice()
          }else {
            if(this.$route.query.yt){
              // 芸泰批量开票
              this.formYTSubmit()
            }else{
              this.formSubmit()
            }
          }
        } else {
          this.$message.warning('请先正确填写信息');
          return false;
        }
      });
    },
    // 芸泰批量开票
    async formYTSubmit() {
      if(this.form.invoice_type == '增值税专用发票') {
        this.form.invoice_type = 1
      }
      let recharge = [];
      for(let key in this.form.ytCategoryList){
        this.form.ytCategoryList[key].category.map(item=>{
          recharge.push({
            id: key,
            category_id: item.category_id,
            money: item.category_money,
            invoice_type: this.form.invoice_type,
            remark: this.form.remark,
          })
        })
      }

      const args = {
        invoice_type: this.form.invoice_type,
        invoice_title: this.form.invoice_title,
        recharge:recharge,
        category_id: this.form.category[0].category_id,
        taxpayer: this.form.taxpayer,
        company_bank: this.form.company_bank,
        company_account: this.form.company_account,
        company_address: this.form.company_address,
        company_phone: this.form.company_phone,
        receiver_fullname: this.form.receiver_fullname,
        receiver_address: this.form.receiver_address,
        remark: this.form.remark,
        receiver_phone: this.form.receiver_phone,
        receiver_email:this.form.receiver_email
      }
		
      let result = await this.$api.createYTInvoiceList(args)
      if(result) {
      console.log(result,'返回结果')
      if(result?.error_list?.length){
        this.errorDialog.visible = true
        this.errorList = result.error_list
        return false
      }
        this.$message.success('保存成功')
        this.$router.push({path:'/invoice'})
      }else {
        this.$message.error('保存失败，请稍后重试');
      }
    },
    //保存表单
    async formSubmit() {
      if(this.form.invoice_type == '增值税专用发票') {
        this.form.invoice_type = 1
      }
      const args = {
        invoice_type: this.form.invoice_type,
        invoice_title: this.form.invoice_title,
        category: JSON.stringify(this.form.category),
        taxpayer: this.form.taxpayer,
        company_bank: this.form.company_bank,
        company_account: this.form.company_account,
        company_address: this.form.company_address,
        company_phone: this.form.company_phone,
        receiver_fullname: this.form.receiver_fullname,
        receiver_address: this.form.receiver_address,
        remark: this.form.remark,
        receiver_phone: this.form.receiver_phone,
        receiver_email:this.form.receiver_email
      }
		
		if(this.isLaowuCompany == 1){
		let orderList = []
		if(this.txRecordList_finallySecond.length == 0){
			this.$message.warning('请选择一个订单');
			return false
		}
		this.txRecordList_finallySecond.map(item=>{
			orderList.push(item.orderNo)
		})
		args.is_labor_dispatch = 1
		args.project_name = this.form.project_name
		args.order_list = orderList
		args.mb_arr = this.laowuForm.mb_arr
		}
		
      let result = await this.$api.createInvoiceList(args)
      if(result) {
		console.log(result,'返回结果')
		if(result.error_list.length != 0){
			this.errorDialog.visible = true
			this.errorList = result.error_list
			return false
		}
        this.$message.success('保存成功')
        this.$router.push({path:'/invoice'})
      }else {
        this.$message.error('保存失败，请稍后重试');
      }
    },
    //获取开票类目
    async getInvoiceCategory() {
        let data = {}
      let shuiyoudiList = ['sycard', 'syalipay', 'sywechat']
      let lignxinList = ['lingxin','lingxincard','lingxinalipay','lingxinwechat']
      if(lignxinList.includes(this.nowCompany.trade_bank_type) ||shuiyoudiList.includes(this.nowCompany.trade_bank_type)){
          if(!this.nowCompany.id || !this.settlement_id){
              this.$message({
                type: 'info',
                message:'开票类目：缺少参数'
              });
          }
          data = {
              name:this.nowCompany?.trade_bank_type,
              company_id:this.nowCompany.id,
              channel_account:this.settlement_id
          }
      }else{
          data = {
              name:'invoice'
          }
      }
      let result = await this.$api.getInvoiceCategory(data)
      if(result) {
        this.options1 = result
      }
    },
    selectCatory() {
      console.log("selectCatory",this.form.category.category_id)
    },
    selectYTCatory() {
      console.log("selectCatory",this.form.ytCategoryList)
    },
    addYTcategory(index){
      let item = {
        category_id: '',
        category_money: '',
      }
      this.form.ytCategoryList[index].category.push(item)
    },
    deleteYTcategory(index,category_index){
      this.form.ytCategoryList[index].category.splice(category_index, 1)
    },
    //编辑开票
    async editInvoice() {
      if(this.form.invoice_type == '增值税专用发票') {
        this.form.invoice_type = 1
      }
      const args = {
        invoice_type: this.form.invoice_type,
        invoice_title: this.form.invoice_title,
        category: JSON.stringify(this.form.category),
        taxpayer: this.form.taxpayer,
        company_bank: this.form.company_bank,
        company_account: this.form.company_account,
        company_address: this.form.company_address,
        company_phone: this.form.company_phone,
        receiver_fullname: this.form.receiver_fullname,
        receiver_address: this.form.receiver_address,
        remark: this.form.remark,
        receiver_phone: this.form.receiver_phone,
        receiver_email:this.form.receiver_email,
        id: this.$route.query.id
      }
      console.log(args,this.form,"args")
      let result = await this.$api.editInvoice(args)
      if(result) {
        this.$message.success('保存成功')
        this.$router.push({path:'/invoice'})
      }else {
        this.$message.error('保存失败，请稍后重试');
      }
    },
    async companyInit(id) {
      let result = await this.$api.getCompanyInfo(id)
      if(result) {
        if(result.info.name) {
          this.form.invoice_title = result.info.name
        }
        if(result.info.account) {
          this.form.company_account = result.info.account
        }
        if(result.info.taxpayer){
          this.form.taxpayer = result.info.taxpayer
        }
        if(result.info.bank) {
          this.form.company_bank = result.info.bank
        }
        if(result.info.address) {
          this.form.company_address = result.info.address
        }
        if(result.info.receiver_fullname) {
          this.form.receiver_fullname = result.info.receiver_fullname
        }
        if(result.info.receiver_phone) {
          this.form.receiver_phone = result.info.receiver_phone
        }
        if(result.info.receiver_email) {
          this.form.receiver_email = result.info.receiver_email
        }
        if(result.info.email) {
          this.form.receiver_address = result.info.email
        }
        if(result.info.company_phone) {
          this.form.company_phone = result.info.company_phone
        }
      }
    },
    //获取开票详情
    async invoiceDetail(id) {
      let args = {id: id}
      let result = await this.$api.getInvoiceView(args)
      if(result) {
        this.$message.success('获取数据成功')
        this.form = result
        this.form.category = result.category_list
        if(result.invoice_type) {
          if(result.invoice_type == 0) {
            this.form.invoice_type = '普通发票'
          }
          if(result.invoice_type == 1) {
            this.form.invoice_type = '增值税专用发票'
          }
        }
        if(result.status == 0) {
          this.active = 1
        }
        if(result.status == 1) {
          this.active = 2
        }
        if(result.status == 2) {
          if(result.invoice_status == 1) {
            this.active = 2
          }
          if(result.invoice_status == 2) {
            this.active = 3
          }
          if(result.invoice_status == 3) {
            this.active = 3
          }
          if(result.invoice_status == 4) {
            this.active = 4
          }
          if(result.invoice_status == 5) {
            this.active = 3
          }
        }
        if(result.status == 3) {
          this.active = 2
        }
      }else {
        this.$message.error('获取数据失败')
      }
    },
	// 获取税局列表
	async laborcompanylist(){
		let result = await this.$api.laborcompanylist({})
		console.log(result)
		this.taxCompany = result
	}
  },
  mounted() {
    this.companyInit(this.mxCompanyId)
    this.getInvoiceCategory()

    if(this.$route.query.id) {
      this.invoiceDetail(this.$route.query.id)
    }
    this.disabled = this.$route.query.disabled
    if(this.$route.query.isLaowuCompany) {
      this.isLaowuCompany = parseInt(this.$route.query.isLaowuCompany)
      if(this.isLaowuCompany){
        this.laborcompanylist()
      }
    }
    if(this.$route.query.yt){
      let selectIds = this.$storage.get('ytBatchId')
      this.selectIds = JSON.parse(selectIds)
      if(!this.selectIds.length) return;
      let ytCategoryList = {};
      this.selectIds.map(item => {
        ytCategoryList[item.id] = {
          id:item.id,
          outer_trade_no:item.outer_trade_no,
          money:item.money,
          category:[{
            category_id: '',
            category_money: item.money,
          }]
        }
      })
      this.form.ytCategoryList = ytCategoryList

    }
  },
};
</script>

<style lang="stylus" scoped>
  .address-select
    width: 85%
  .manage-bill-btn
    margin-left: 20px
  .bill-info-form
    margin-top: 40px
  .bill-info
    display: flex
    flex-direction: column
    width: 90%
    height: 80px
    padding: 20px 0
  .bill-info-title
    width:100%
  .bill-mail-info
    width: 70%
    max-width: 600px;
    margin: 0px auto
    margin-top: 40px
    padding: 0 25%
    padding-top: 50px
    padding-bottom: 20px
    border-top: 1px solid #dcdfe6
    border-bottom: 1px solid #dcdfe6
  /deep/.bill-mail-info .el-form-item
    display: flex
    flex-direction: row
  /deep/.el-form--label-top .el-form-item__label
    position: relative
  /deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
  /deep/.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before
    position: absolute
    left: -10px
  /deep/.bill-mail-info .el-form-item .el-form-item__content
    width: 100%
  .mail-info-title
    width: 130px
  .business-address
    display: flex
  .save-btn-wrapper
    display: flex
    justify-content: flex-end
    margin-top: 30px
    margin-bottom: 30px
  .priceIcon
    font-size: 30px
    color: #e6a23c
    margin-top: 3px
    margin-left: 10px
  .alert
    margin-top: 40px
  /deep/.steps .el-steps--simple
    background: #fff
    padding: 13px 0%;
  /deep/.steps .el-steps--simple .el-step__title
    width: 80%
    text-align: center
    height: 40px
    line-height: 40px
    padding: 0 10px
    background: #959595
    color: #fff
  /deep/ .steps .el-step.is-simple:not(:last-of-type) .el-step__title
    max-width: 80%
  /deep/.steps .el-step__head
    display: none
  /deep/.steps .el-steps--simple .el-step__title.is-success
    background: #00B79E
  .icon
    font-size: 30px
  .fenge
    border-top: 1px solid #dcdfe6
    margin-top: 50px
    padding-top: 30px
    width: 99%
  .red
    color red
</style>






